import angular from 'angular';
import ensureTranslations from './translationLoader';

const bootstrapAngular = (appModuleName, domain) => ensureTranslations(domain)
    .then(() => angular.element(document).ready(() => angular.bootstrap(document, [appModuleName])));

export default bootstrapAngular;
